import Vue from 'vue';

// Vant
// import Vant from 'vant';
// import 'vant/lib/index.css';
import {
  Button,
  Swipe,
  SwipeItem,
  Card,
  ActionSheet,
  Field,
  CountDown,
  List,
  Grid,
  GridItem,
  Image,
  PullRefresh,
  Overlay,
  Tag,
  Icon,
  RadioGroup,
  Radio,
  Tabs,
  Tab,
  NavBar,
  Stepper,
  SubmitBar,
  AddressEdit,
  Area,
  Cascader,
  Popup,
  Toast,
  Dialog,
  Form,
  Switch,
  Cell,
  Divider,
  Slider,
  Loading
} from 'vant';
Vue.use(Button);
Vue.use(Toast);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Card);
Vue.use(ActionSheet);
Vue.use(Field);
Vue.use(CountDown);
Vue.use(List);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(PullRefresh);
Vue.use(Overlay);
Vue.use(Tag);
Vue.use(Icon);
Vue.use(RadioGroup);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Radio);
Vue.use(Image);
Vue.use(NavBar);
Vue.use(Stepper);
Vue.use(SubmitBar);
Vue.use(AddressEdit);
Vue.use(Area);
Vue.use(Cascader);
Vue.use(Popup);
Vue.use(Form);
Vue.use(Dialog);
Vue.use(Switch);
Vue.use(Cell);
Vue.use(Divider);
Vue.use(Slider);
Vue.use(Loading);
